import { TemporaryAccessPassParams } from '../types/TemporaryAccessPassParams';
import { TemporaryAccessPassResponse } from '../types/TemporaryAccessPassResponse';
import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import Problem from "../types/Problem";

export const useGenerateTemporaryAccessPass = () => {
    const url = 'accountmanagement/generatetemporaryaccesspass';

    return useMutation<AxiosResponse<TemporaryAccessPassResponse>, AxiosError<Problem>, TemporaryAccessPassParams>({
        mutationFn: (p) => axios.post(url, p, { headers: { "Content-Type": "application/json" } }),
    });
};
